import httpClient from "../../api/httpClient";
import ParametroPortal from "../classes/ParametroPortal";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET",   rota: "ParametroPortal/All" },
  { method: "GET",   rota: "ParametroPortal/{id}" },  
  { method: "POST",  rota: "ParametroPortal/Adicionar" },
  { method: "PUT",   rota: "ParametroPortal/Atualizar" },
  { method: "POST",  rota:"ParametroPortal/Apagar"},
];
                               
const apiServico: String = "PORTAL"

class ParametroPortalDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }
  async Adicionar(value: ParametroPortal) {
    return await super.post(calls[2].rota, value);
  }

  async Atualizar(value: ParametroPortal) {
    return await super.put(calls[3].rota, value);
  }

  async Apagar(value: ParametroPortal) {
    return await super.post(calls[4].rota, value);
  }

  async ListarAtivos(): Promise<ParametroPortal[]> {
    return await super.Get(calls[0].rota )
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }
}
export default ParametroPortalDataset;

